import { useQuery } from '@tanstack/react-query';
import { getHealth, type HealthResponse } from '@/lib/api';

/**
 * Hook to fetch API health status.
 */
export function useHealth() {
  return useQuery<HealthResponse, Error>({
    queryKey: ['health'],
    queryFn: getHealth,
    staleTime: 10_000, // 10 seconds - matches CloudFront cache
    refetchInterval: 30_000, // Refetch every 30 seconds
    retry: false, // Don't retry health checks
  });
}
